<template>
  <div class="cookie-consent">
    <h1>СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ</h1>

    <section>
      <p>
        Я, Пользователь сайта <a href="http://an-merkuriy.ru/">http://an-merkuriy.ru/</a> (далее — «Сайт»), даю согласие
        на обработку персональных данных индивидуальным предпринимателем Меркурьевой Марией Викторовной (ИНН
        616304742897, ОГРНИП 317619600101031) с использованием средств автоматизации на следующих условиях.
      </p>
    </section>

    <section>
      <h2>1. Категории обрабатываемых данных</h2>
      <p>
        Файлы cookie — фрагменты данных, отправленные сервером и хранимые на устройстве Пользователя. Содержимое файлов
        cookie может включать или не включать персональные данные, в зависимости от того, содержат ли они персональную
        информацию или обезличенные технические данные. Согласие выдано на обработку следующих данных:
      </p>
      <p>1.1. IP-адрес, тип браузера и устройства, с которого выполняется вход на Сайт;</p>
      <p>1.2. Операционная система и данные об интернет-провайдере;</p>
      <p>1.3. Информация о стране, из которой выполняется вход;</p>
      <p>1.4. Дата и время посещения Сайта, а также количество кликов Пользователя.</p>
    </section>

    <section>
      <h2>2. Цель обработки персональных данных</h2>
      <p>
        Повышение удобства пользования Сайтом. Согласие является конкретным, предметным, информированным, сознательным и
        однозначным.
      </p>
    </section>

    <section>
      <h2>3. Категории субъектов персональных данных</h2>
      <p>
        Все Пользователи Сайта, которые дали согласие на обработку файлов cookie, нажав кнопку «Принять» в уведомлении
        об использовании файлов cookie или продолжив пользоваться Сайтом после получения уведомления.
      </p>
    </section>

    <section>
      <h2>4. Способы обработки</h2>
      <p>
        Сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение,
        использование, блокирование, уничтожение персональных данных.
      </p>
    </section>

    <section>
      <h2>5. Срок обработки и хранения</h2>
      <p>
        До момента отзыва Пользователем согласия или изменения настроек браузера, но не более 10 лет.
      </p>
    </section>

    <section>
      <h2>6. Отключение файлов cookie</h2>
      <p>
        Пользователь может в любой момент отключить файлы cookie в настройках браузера или удалить ранее загруженные
        файлы cookie. Если Пользователь не отключает файлы cookie, дополнительные действия не требуются. Информация
        файлов cookie на Сайте Оператора не хранится.
      </p>
    </section>

    <section>
      <h2>7. Способ отзыва</h2>
      <p>
        Направление уведомления Оператору на электронный адрес <a href="mailto:an.merkuriy@yandex.ru">an.merkuriy@yandex.ru</a>
        с пометкой «Отзыв согласия на обработку персональных данных».
      </p>
    </section>

    <section>
      <h2>8. Порядок уничтожения персональных данных</h2>
      <p>
        При достижении цели обработки данные уничтожаются автоматически.
      </p>
    </section>

    <section>
      <h2>9. Подтверждение согласия</h2>
      <p>
        Пользователь подтверждает, что текст Согласия прочитан и понятен. Согласие является конкретным, предметным,
        информированным и однозначным. Датой выдачи согласия считается дата совершения конклюдентных действий —
        продолжение пользования Сайтом.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent'
}
</script>

<style scoped>
  .cookie-consent {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
    line-height: 1.6;
  }
  h1 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: center;
  }
  h2 {
    font-size: 20px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  p {
    margin-bottom: 10px;
  }
  a {
    color: #007bff;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
  @media (max-width: 768px) {
    .cookie-consent {
      padding: 15px;
    }
    h1 {
      font-size: 20px;
    }
    h2 {
      font-size: 18px;
    }
    p {
      font-size: 14px;
    }
  }
  @media (max-width: 480px) {
    .cookie-consent {
      padding: 10px;
    }
    h1 {
      font-size: 18px;
    }
    h2 {
      font-size: 16px;
    }
    p {
      font-size: 12px;
    }
  }
</style>
